require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// /home/runner/work/slipresistant/slipresistant/client/~/babel-polyfill/~/core-js/modules/es7.symbol.observable.js
// module id = LNwc
// module chunks = 0 3